import React, { useState, useEffect } from 'react';
import '../styles/HeroSlider.css';

const HeroSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      image: "https://metroblue.com.ng/assets/website/slider/carousel1.png",
      title: "Business Management?",
      description: "MetroBlue have got amazing solutions to help you start, grow or expand your business.",
      link: "https://metroblue.com.ng/enterprise"
    },
    {
      image: "https://metroblue.com.ng/assets/website/slider/carousel2.png",
      title: "Educational Institution Management?",
      description: "MetroBlue have got amazing solutions to help you manage your institution with an effective database management system and faster computational processes.",
      link: "https://metroblue.com.ng/educesol"
    },
    {
      image: "https://metroblue.com.ng/assets/website/slider/carousel3.png",
      title: "Want to make money Online?",
      description: "MetroBlue have got amazing Digital Solutions for both resellers and end-users to get digital products like airtime, data, utility bills, and lots more at cheaper rates.",
      link: "https://metroblue.com.ng/metroblits"
    }
  ];

  // Function to split title and highlight the last word
  const renderTitle = (title) => {
    const words = title.split(' ');
    const lastWord = words.pop(); // Remove the last word (which includes the ?)
    
    return (
      <>
        {words.join(' ')} <span className="highlight">{lastWord}</span>
      </>
    );
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    
    return () => clearInterval(interval);
  }, [slides.length]);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const goToPrev = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNext = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <div className="hero-slider">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div 
            key={index}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          >
            <div className="slide-content">
              <h2 className="slide-title">
                {renderTitle(slide.title)}
              </h2>
              <p className="slide-description">{slide.description}</p>
              <a href={slide.link} className="slide-button">Learn more...</a>
            </div>
          </div>
        ))}
      </div>
      
      <div className="slider-indicators">
        {slides.map((_, index) => (
          <button
            key={index}
            className={`indicator ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          ></button>
        ))}
      </div>
      
      <button className="slider-nav prev" onClick={goToPrev}>
        <i className="fa fa-chevron-left"></i>
      </button>
      <button className="slider-nav next" onClick={goToNext}>
        <i className="fa fa-chevron-right"></i>
      </button>
    </div>
  );
};

export default HeroSlider;